var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartPenEnroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1006 19.9933L13.8429 19.1614C14.7536 18.1407 16.3877 18.2734 17.1218 19.4277C17.8057 20.503 19.2915 20.7068 20.2397 19.8554L21.5852 18.6474M3.54297 20.2204L7.90895 19.3407C8.14073 19.294 8.35355 19.1798 8.52068 19.0126L18.2944 9.23356C18.763 8.76471 18.7626 8.00472 18.2936 7.53626L16.2232 5.46818C15.7544 4.99991 14.9948 5.00023 14.5264 5.46889L4.75173 15.2489C4.58492 15.4158 4.47102 15.6282 4.42427 15.8595L3.54297 20.2204Z",
    stroke: "#6F6F6F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartPenEnroll);
export default __webpack_public_path__ + "static/media/SmartPenEnroll.19862976aba0b6a8a7b4db49b8e70708.svg";
export { ForwardRef as ReactComponent };